var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainVsSometimesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 5885"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2067",
    d: "M0 4.18189C0 3.07732 0.895431 2.18188 2 2.18188H13.3333V21.8182H2C0.895428 21.8182 0 20.9228 0 19.8182V4.18189Z",
    fill: "#104239"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2068",
    x: 13.334,
    width: 2.66667,
    height: 24,
    rx: 1.33333,
    fill: "#104239"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 2067_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_725_116822",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 19.8181C24 20.9227 23.1046 21.8181 22 21.8181L18.6667 21.8181L18.6667 2.18175L22 2.18175C23.1046 2.18175 24 3.07718 24 4.18175L24 19.8181Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26 19.8181C26 22.0273 24.2091 23.8181 22 23.8181L18.6667 23.8181L18.6667 19.8181L22 19.8181L26 19.8181ZM18.6667 0.181753L22 0.181753C24.2091 0.181753 26 1.97261 26 4.18175L22 4.18175L18.6667 4.18175L18.6667 0.181753ZM22 0.181753C24.2091 0.181753 26 1.97261 26 4.18175L26 19.8181C26 22.0273 24.2091 23.8181 22 23.8181L22 19.8181L22 4.18175L22 0.181753ZM18.6667 21.8181L18.6667 2.18175L18.6667 21.8181Z",
    fill: "#104239",
    mask: "url(#path-3-inside-1_725_116822)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainVsSometimesIcon);
export default __webpack_public_path__ + "static/media/main-vs-sometimes-icon.b133de86ed2babf321fa36f7a71b6476.svg";
export { ForwardRef as ReactComponent };